module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "modal_download_layer"
    }
  }, [_c('div', {
    staticClass: "flex-modal",
    class: {
      'animate-flex-modal': _vm.show === true
    }
  }, [_c('div', {
    staticClass: "dismiss",
    on: {
      "click": function($event) {
        _vm.dismiss()
      }
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("close")])]), _vm._v(" "), _c('h5', [_vm._v(_vm._s(_vm.$t('title')))]), _vm._v(" "), _c('h6', {
    attrs: {
      "id": "desc"
    }
  }, [_vm._v(_vm._s(_vm.$t('desc')))]), _vm._v(" "), _c('ul', {
    staticClass: "list-unstyled",
    attrs: {
      "id": "list-downloadlayers"
    }
  }, _vm._l((_vm.layersItem), function(item, index) {
    return _c('li', _vm._l((item.layers), function(item1, index1) {
      return _c('div', {
        on: {
          "click": function($event) {
            _vm.showDownloadOptions(item1)
          }
        }
      }, [_c('i', {
        staticClass: "material-icons size18px"
      }, [_vm._v("save_alt")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(item1.serverName))])])
    }))
  })), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "body-download"
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-tornar",
    attrs: {
      "id": "bt_download_tancar",
      "lang": "ca",
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.hideDownloadOptions()
      }
    }
  }, [_vm._v("Tornar a la llista")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-info",
    attrs: {
      "id": "bt_download_accept",
      "lang": "ca",
      "type": "button"
    }
  }, [_vm._v("Acceptar")])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "modal-body-download"
    }
  }, [_c('div', {
    staticClass: "input-group input-group-sm"
  }, [_c('span', {
    staticClass: "input-group-addon",
    attrs: {
      "lang": "ca"
    }
  }, [_vm._v("Guardar com")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "lang": "ca",
      "type": "text",
      "id": "input-download-name",
      "placeholder": "Nom fitxer"
    }
  })]), _vm._v(" "), _c('small', {
    staticClass: "label label-default",
    attrs: {
      "lang": "ca"
    }
  }, [_vm._v("Opcional: en blanc s'assignarà un nom automàtic")]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('div', [_c('span', [_vm._v("Format")]), _vm._v(": \n\t\t\t\t\t\t"), _c('select', {
    staticClass: "form-download-format",
    attrs: {
      "id": "select-download-format"
    }
  }, [_c('option', {
    attrs: {
      "value": "GeoJSON#.geojson"
    }
  }, [_vm._v("GeoJSON")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "GPKG#.gpkg"
    }
  }, [_vm._v("GeoPackage")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "ESRI Shapefile#.shp"
    }
  }, [_vm._v("ESRI Shapefile")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "DXF#.dxf"
    }
  }, [_vm._v("DXF")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "KML#.kml"
    }
  }, [_vm._v("KML")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "GPX_TRACK#.gpx"
    }
  }, [_vm._v("GPX Track (Ex:Wikiloc)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "GPX_ROUTE#.gpx"
    }
  }, [_vm._v("GPX Route")])]), _vm._v(" "), _c('br'), _c('br'), _vm._v("\n\t\t\t\t\t\tEPSG: \n\t\t\t\t\t\t"), _c('select', {
    staticClass: "form-download-epsg",
    attrs: {
      "id": "select-download-epsg"
    }
  }, [_c('option', {
    attrs: {
      "value": "EPSG:4326"
    }
  }, [_vm._v("EPSG:4326 (WGS84 geogràfiques (lat, lon) - G.G)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "EPSG:23031"
    }
  }, [_c('b', [_vm._v("EPSG:23031")]), _vm._v(" (ED50-UTM 31N Easting,Northing o X,Y)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "EPSG:25831"
    }
  }, [_vm._v("EPSG:25831 (ETRS89-UTM 31N Easting,Northing o X,Y)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "EPSG:4258"
    }
  }, [_vm._v("EPSG:4258 INSPIRE(ETRS89 geogràfiques (lat, lon) - G.G)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "EPSG:4230"
    }
  }, [_vm._v("EPSG:4230 (ED50 geogràfiques (lat, lon) - G.G)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "EPSG:32631"
    }
  }, [_vm._v("EPSG:32631 (WGS84 31N Easting,Northing o X,Y)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "EPSG:32630"
    }
  }, [_vm._v("EPSG:32630 (WGS84 30N Easting,Northing o X,Y)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "EPSG:3857"
    }
  }, [_vm._v("EPSG:3857 (WGS84 Pseudo-Mercator Easting,Northing o X,Y)")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-36bfbecd"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/map-viewer/components/downloadlayers-modal/downloadlayers-modal.vue
// module id = 127
// module chunks = 0